// Utils
import {
  getWinnerReason,
  getStatusDate,
  getNameByStatus,
  LinkCreationService,
  getMatchDate,
  formatGameScore,
  formatGameStatus,
} from '@sportal365/smp-widget-utils';

// Constants
import { assetsPlaceholder } from '../../../../../packages/constants/assetsPlaceholder';
import { FINISHED, LIVE, NOT_STARTED } from '../../../../../packages/constants/statusTypes';
import { TARGET_BLANK, TARGET_SELF } from '../../../../../packages/constants/windowTarget';

// Types
import { IFootballConfig, IMatchV2, SDKDateOptions } from '../../../../../packages/types';

interface Params {
  matches?: IMatchV2[];
  dataTeamNameType?: IFootballConfig['dataTeamNameType'];
  dataEntityLinks?: IFootballConfig['dataEntityLinks'];
  sdkOptions: SDKDateOptions;
}

export const normalizeRoundMatches = ({ matches, dataTeamNameType, dataEntityLinks, sdkOptions }: Params) => {
  const linkService = dataEntityLinks && new LinkCreationService(dataEntityLinks);
  const target = dataEntityLinks?.configuration?.newWindow ? TARGET_BLANK : TARGET_SELF;

  return matches?.map(({ id, slug, kickoff_time, status, minute, home_team, away_team, score, season, odds, winner }) => ({
    id,
    date: kickoff_time && status?.type ? getStatusDate(kickoff_time, status?.type, sdkOptions) : '',
    status: formatGameStatus(status, minute),
    startTime: status?.type === NOT_STARTED && kickoff_time ? getMatchDate(kickoff_time, sdkOptions, 'HH:mm') : '',
    isLive: status?.type === LIVE,
    isFinished: status?.type === FINISHED,
    minute: minute,
    score: formatGameScore(score?.display?.home, score?.display?.away, status).score,
    url: linkService?.createMatchUrl(id, home_team, away_team, slug) ?? '#',
    target: target,
    tournament: season?.tournament?.name ?? '',
    homeTeam: {
      id: home_team.id,
      name: getNameByStatus({ ...home_team, status: dataTeamNameType }),
      logo: home_team.assets?.logo?.url ?? assetsPlaceholder.team,
      score: formatGameScore(score?.display?.home, score?.display?.away, status).homeScoreResult,
      isWinner: winner?.match?.id === home_team.id,
      winnerReason: getWinnerReason(home_team.id, winner),
    },
    awayTeam: {
      id: away_team.id,
      name: getNameByStatus({ ...away_team, status: dataTeamNameType }),
      logo: away_team.assets?.logo?.url ?? assetsPlaceholder.team,
      score: formatGameScore(score?.display?.home, score?.display?.away, status).awayScoreResult,
      isWinner: winner?.match?.id === away_team.id,
      winnerReason: getWinnerReason(away_team.id, winner),
    },
    odds: odds && odds.length ? odds : [],
  }));
};
